module.exports = __webpack_public_path__ + "bcfb4f9eddc54e1b329d07997a1cfb68.MP3";